import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import { useOrganizationMetadata } from '../hooks/useBrands';

// Page names match the nav tabs in Header.tsx.
const PAGE_NAMES: Array<[string, string]> = [
  ['/brand-tracker', 'Brand Tracker'],
  ['/pillar-breakdown', 'Pillar Breakdown'],
  ['/keyword-analysis', 'Keyword Analysis'],
  ['/image-comparison', 'Image Comparison'],
  ['/employee-brand/general', 'General Metrics'],
  ['/employee-brand/personal', 'Personal Metrics'],
];

const PageHeader: React.FC<{ condensed?: boolean }> = ({ condensed = false }) => {
  const { orgId: orgIdStr } = useParams<{ orgId: string }>();
  const orgId = parseInt(orgIdStr || '0', 10);
  const { metadata } = useOrganizationMetadata(orgId);
  const { pathname } = useLocation();
  const pageName = PAGE_NAMES.find(([suffix]) => pathname.includes(suffix))?.[1];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5, minWidth: 0 }}>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          color: 'text.primary',
          fontSize: { xs: '1.75rem', md: '2.125rem', lg: condensed ? '1.375rem' : '2.125rem' },
          overflowWrap: 'anywhere',
          transition: 'font-size 150ms ease',
          '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
        }}
      >
        {metadata?.organization_name || 'Loading...'}
      </Typography>
      {pageName && (
        <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 500, display: { lg: condensed ? 'none' : 'block' } }}>
          {pageName}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
